import { AccountType, YesNo } from "@/types";
import { FieldRow } from "@/components/molecules/FieldsTable";
import { NotAvailable } from "../../Dashboard/RequestDetails/NotAvailable";
import { readableAccountType } from "@/utils/accounts";

export const HastingsDirectAccount = ({ account }: { account: any }) => {
  return (
    <>
      <FieldRow
        label="Policy number"
        value={account.accountNumber ? account.accountNumber : <NotAvailable />}
      />

      <FieldRow label="Account number" value={account.holderNumber || <NotAvailable />} />

      <FieldRow
        label="Account type"
        value={
          account.accountType ? (
            readableAccountType(account.accountType, account.accountTypeOther)
          ) : (
            <NotAvailable />
          )
        }
      />

      {(account.accountType === AccountType.Vehicle ||
        account.accountType === AccountType.BreakdownCover) && (
        <>
          <FieldRow
            label="Vehicle make"
            value={account.vehicleMake ? account.vehicleMake : <NotAvailable />}
          />
          <FieldRow
            label="Vehicle model"
            value={account.vehicleModel ? account.vehicleModel : <NotAvailable />}
          />
          <FieldRow
            label="Vehicle registration number"
            value={
              account.vehicleRegistrationNumber ? (
                account.vehicleRegistrationNumber
              ) : (
                <NotAvailable />
              )
            }
          />
        </>
      )}

      <FieldRow label="Joint policy?" value={account.jointClaim === YesNo.Yes ? "Yes" : "No"} />
    </>
  );
};
